import React from "react";
import { SkeletonLoader } from "@activecollab/components";

export const CalendarTasksLoader = () => {
  return (
    <div className="tw-p-6 tw-flex tw-flex-col tw-gap-6">
      <div className="tw-flex tw-flex-col">
        <div className="tw-h-8 tw-w-full tw-max-w-[200px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-6" />
        </div>
        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>

        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>
        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>
      </div>
      <div className="tw-flex tw-flex-col">
        <div className="tw-h-8 tw-w-full tw-max-w-[200px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-6" />
        </div>
        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>

        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>
        <div className="tw-h-10 tw-w-full tw-max-w-[400px] tw-flex tw-items-center">
          <SkeletonLoader className="tw-w-full tw-h-4" />
        </div>
      </div>
    </div>
  );
};
